import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type SubmitButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "buttonType" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
};

const SubmitButton = ({ label = "Submit", loadingText = "Submitting...", ...props }: SubmitButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="submit"
            testId="submit-button"
            buttonType="submit"
            {...props}
        />
    );
};

export default SubmitButton;
